import React from 'react';
import _ from 'lodash';

import { useReturnedProductsWidgetQuery } from 'generated/graphql';
import Big from 'big.js';



export interface ILineItem {
  id: string;
  productName: string;
  sku: string;
  quantity: number;
  refundAmountCents: Big;
  isReceived: boolean;
  reasonForReturn: string;
}

export interface IData {
  hasItemReceipt: boolean;
  lineItems: ILineItem[];
}

export function useQuery(returnAuthorizationId: string, queryAsCustomer: boolean) {
  const tuple = useReturnedProductsWidgetQuery({
    variables: {
      returnAuthorizationId,
      queryAsCustomer
    }
  });

  return React.useMemo(
    () => {
      if (queryAsCustomer) {
        const data: IData = {
          hasItemReceipt: false,
          lineItems: _.map(tuple.data?.returnAuthorizationLite?.lineItems ?? [], (lineItem): ILineItem => ({
            id: lineItem.id,
            isReceived: false,
            productName: lineItem.productName,
            quantity: lineItem.quantity,
            refundAmountCents: new Big(0),
            sku: lineItem.sku,
            reasonForReturn: lineItem.reasonForReturn
          }))
        };
        return {
          ...tuple,
          data
        };

      } else {
        const receivedSkus = _.map(
          tuple.data?.returnAuthorization?.itemReceipt?.lineItems,
          li => li.product.sku
        );

        const data: IData = {
          hasItemReceipt: !_.isNil(tuple.data?.returnAuthorization?.itemReceipt),
          lineItems: _.map(tuple.data?.returnAuthorization?.lineItems ?? [], (lineItem): ILineItem => ({
            id: lineItem.id,
            reasonForReturn: lineItem.reasonForReturn,
            isReceived: _.includes(receivedSkus, lineItem.product.sku),
            productName: lineItem.product.name,
            quantity: lineItem.quantity,
            refundAmountCents: new Big(lineItem.refundAmountCents),
            sku: lineItem.product.sku
          }))
        };

        return {
          ...tuple,
          data
        };
      }
    },
    [
      tuple,
      queryAsCustomer
    ]
  );
}
